import { Fragment } from 'react';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import PersonSearch from 'shell/components/shared/person-search';
import ActionsList from 'mutation/components/registration-widowhood/actions-list';
import { SearchPersonRegistrationWidowhoodCrumbs } from 'mutation/constants/registration-widowhood-crumbs';
import { __PERSON_API_URL__ } from 'shell/constants/environment';

const SearchPersonWidowhoodPage = (): React.ReactElement => {
  return (
    <Fragment>
      <Breadcrumbs items={SearchPersonRegistrationWidowhoodCrumbs} />
      <PersonSearch
        pathname="/mutazioni/persona/vedovanza/registrazione"
        action={ActionsList}
        addedTitle={'- Registrazione Vedovanza'}
        url={`${__PERSON_API_URL__}/ricerca-persona/registrazione-vedovanza`}
      />
    </Fragment>
  );
};

SearchPersonWidowhoodPage.displayName = 'Persons page component';

export default SearchPersonWidowhoodPage;
